import { Box, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import {
  blackColor,
  blueColor04,
  blueColor101,
  blueColor102,
  colorOrangeLight01,
  greenColor16,
  greyColor062,
  lightBlueColor04,
  lightBlueColor05,
  lightGreen16,
  lightPerpleColor1,
  lightSkyBlue01,
  orangeShade08,
  perpleColor1,
  tamrindColor01,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import ScheduleIcon from "@mui/icons-material/Schedule";
import { formatMinutes } from "../../../utils/helper";
import OrderSaleAvgSectionDrillDown from "./OrderSaleAvgSectionDrillDown";

function OrderSaleAvgSection({
  orderReportAvg,
  allBranchIds,
  getBrandNameById,
  masterBranchInfo,
}) {
  const [showDrillDown, setShowDrillDown] = useState(false);

  const handleClick = () => {
    setShowDrillDown(true);
  };
  return (
    <>
      <Stack
        sx={{
          p: "15px 12px",
          background: blueColor101,
          borderRadius: "10px",
          border: "1px solid" + blueColor102,
          gap: "10px",
          cursor:'pointer'
        }}
        minHeight={"100%"}
        onClick={handleClick}
      >
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Stack>
            <Typography
              color={greyColor062}
              fontSize={12}
              fontWeight={400}
              lineHeight="25px"
            >
              Avg Order Value:
            </Typography>
            <Typography
              color={blackColor}
              fontSize={15}
              fontWeight={600}
              lineHeight={1.5}
            >{`₹ ${orderReportAvg?.avgOrderValue?.toLocaleString(
              "en-IN"
            )}`}</Typography>
          </Stack>
          <Box
            sx={{
              width: "35px",
              height: "35px",
              color: whiteColor,
              background: blueColor04,
              border: "1px solid " + whiteColor,
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <CalendarMonthIcon sx={{ fontSize: "16px" }} />
          </Box>
        </Box>

        <Box
          display="flex"
          flexWrap="wrap"
          sx={{
            background: whiteColor,
            p: "10px",
            borderRadius: "10px",
            gap: "10px",
          }}
        >
          <InfoCard
            label="Avg Approval Time:"
            value={formatMinutes(orderReportAvg?.avgApprovalTime)}
            bgColor={colorOrangeLight01}
            color={orangeShade08}
            icon={<ScheduleIcon sx={{ fontSize: 22, color: orangeShade08 }} />}
          />
          <InfoCard
            label="Avg Shipping Time:"
            value={formatMinutes(orderReportAvg?.avgShippingTime)}
            bgColor={lightPerpleColor1}
            color={tamrindColor01}
            icon={<ScheduleIcon sx={{ fontSize: 22, color: tamrindColor01 }} />}
          />
          <InfoCard
            label="Avg Order Cycle Time:"
            value={formatMinutes(orderReportAvg?.avgOrderCycleTime)}
            bgColor={lightGreen16}
            color={greenColor16}
            icon={
              <LocalShippingIcon sx={{ fontSize: 22, color: greenColor16 }} />
            }
          />
        </Box>
      </Stack>

      {showDrillDown && (
        <OrderSaleAvgSectionDrillDown
          allBranchIds={allBranchIds}
          open={showDrillDown}
          setOpen={setShowDrillDown}
          getBrandNameById={getBrandNameById}
          masterBranchInfo={masterBranchInfo}
        />
      )}
    </>
  );
}

export default OrderSaleAvgSection;

const InfoCard = ({ icon, label, value, color, bgColor }) => (
  <Stack
    sx={{
      background: bgColor,
      borderRadius: "6px",
      flex: "calc(50% - 10px)",
      p: "10px 10px 12px",
    }}
  >
    <Box
      sx={{
        width: "35px",
        height: "35px",
        background: whiteColor,
        borderRadius: "8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        mb: "5px",
      }}
    >
      {icon}
    </Box>
    <Typography color={color} fontSize={11} fontWeight={500} lineHeight="20px">
      {label}
    </Typography>
    <Typography color={color} fontSize={13} fontWeight={600} lineHeight="20px">
      {value}
    </Typography>
  </Stack>
);
